//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import signHead from './components/sign-head/index.vue'
import loadListMx from './mixins/load-list.js'
import api from '@/common/urls/url.js';

export default {
  name: 'exchange',
  mixins: [loadListMx(api.SIGN.bonusExchangeHistory)],
  components: { signHead },
  data() {
    return {
      
    }
  },
  methods: {
    resetList(list) {
      list.forEach((item) => {
        if (item.prizeType === '1') item.prizeTxt = val.prize
        if (item.prizeType === '2') item.prizeTxt = this.$t('signIn').cashBonus
      })
      return list
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/sign/exchange.vue